export function copyToClipboard(value: string) {
  // Wrap in a promise to catch errors accessing navigator.clipboard
  return new Promise((resolve) => {
    resolve(window.navigator.clipboard.writeText(value));
  });
}
